import axios from 'axios';

const instance = axios.create({
    baseURL: process.env.REACT_APP_URL_API_LOGIN,
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept, Authorization',
    },
    timeout: process.env.REACT_APP_TIMEOUT_API,
});

instance.interceptors.response.use((response) => {
    return response.data;
});

export default instance;
